import { MultipleCompaniesPartialTreydUser } from '@/types/user';
import { TypedDocumentNode, gql } from '@apollo/client';

export const getUserCompaniesQuery = gql`
  query getUserCompanies($userId: Int!) {
    lager_treyd_users(
      where: {
        _and: {
          invitation_accepted_at: { _is_null: false }
          user_id: { _eq: $userId }
        }
      }
    ) {
      name
      company_user_id
      company {
        id
        name
      }
    }
  }
` as TypedDocumentNode<
  { lager_treyd_users: Array<MultipleCompaniesPartialTreydUser> },
  { userId: number }
>;
